import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import {
  AlertService,
  GrowlType,
} from '../../../infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { SxContextService } from '../../../infrastructure/services/sxContext.service';

import { BusinessLogicService } from 'app/infrastructure/services/businessLogic.service';

import { ConfigurationTypeService } from 'app/infrastructure/services/configurationType.service';
import {
  OrganizationCategory,
  BusinessLogic,
} from 'app/infrastructure/model/interfaces/businessLogic.interface';
import { ConfigurationType } from 'app/infrastructure/model/interfaces/configurationType.interface';
import { AutoCompleteService } from 'ng4-auto-complete';

@Component({
  templateUrl: './detail-business-logic.component.html',
  styleUrls: ['./detail-business-logic.component.css']
})
export class DetailBusinessLogicComponent {
  regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
  url: string;
  preset: string;
  username: string;
  password: string;
  businessLogicCode: string;
  completitud = 0;
  isLoading = false;
  editarContexto = false;
  isNew = false;
  checkeandCodigo = false;
  errors: any = [];
  typeOptions: ConfigurationType[];
  filteredTypeOptions: ConfigurationType[];
  optionSelectedType: string;
  inputLastValue: string;
  showFilterTypeOptions: boolean = false;
  showAddTypeButton: boolean = false;

  selectedOrganization: OrganizationCategory = {
    idCategory: null,
    organizationCode: null,
  };
  businessLogic: BusinessLogic = {
    idBusinessLogic: null,
    name: null,
    description: null,
    type: null,
    json: null,
    organizationCategorySelected: {
      idCategory: null,
      organizationCode: null,
    },
    categories: null,
  };
  options: any = { maxLines: 1000, printMargin: true };

  constructor(
    public loader: LoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private contextService: SxContextService,
    private businessLogicSrv: BusinessLogicService,
    private translator: Translator,
    private alertService: AlertService,
    private configurationTypeSrv: ConfigurationTypeService,
    private autocompleteSrv: AutoCompleteService
  ) {}

  ngOnInit() {
    this.getCategoryTypes();
    this.route.params.subscribe((params) => {
      this.businessLogicCode = params['codbusinesslogic'];
      if (this.businessLogicCode === undefined) {
        this.isNew = true;
        this.getOrganizations();
        return;
      }

      this.businessLogicSrv
        .getById(this.businessLogicCode)
        .subscribe((data) => {
          if (!data) return this.router.navigateByUrl('/soc/404');
          this.businessLogic = data;
          this.businessLogic.json = JSON.stringify(
            JSON.parse(this.businessLogic.json),
            null,
            2
          );
        });
    });
  }

  save() {
    if (this.validarCodigo()) {
      this.checkeandCodigo = true;
      this.businessLogicSrv.create(this.businessLogic).then((res) => {
        if (res) {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'SISTEMA_CREADO_CORRECTAMENTE',
          });
          this.router.navigate(['../'], { relativeTo: this.route });
        } else {
          this.alertService.showGrowl({
            type: GrowlType.DANGER,
            body: 'ERROR',
          });
        }
      });
    }
  }

  update(){
    if (this.validarCodigo()) {
      this.checkeandCodigo = true;
      this.businessLogicSrv.update(this.businessLogic).then((res) => {
        if (res) {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'SISTEMA_CREADO_CORRECTAMENTE',
          });
          this.router.navigate(['../'], { relativeTo: this.route });
        } else {
          this.alertService.showGrowl({
            type: GrowlType.DANGER,
            body: 'ERROR',
          });
        }
      });
    }
  }

  validarCodigo() {
    this.errors = [];

    if(this.businessLogic.idBusinessLogic){
      const validGuid = this.regexGuid.test(this.businessLogic.idBusinessLogic.toString());
      if(validGuid === false){
        this.errors['guid'] = <string>(
          this.translator.instant('GUID_INVALID')
        );
        return false;
      } else {
        return true;
      }
    }
    
    if (!this.businessLogic.name || this.businessLogic.name.length <= 0) {
      this.errors['name'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else if (this.businessLogic.name.length > 10) {
      this.errors['name'] = <string>(
        this.translator.instant('MAX_LONGITUD', { max: 10 })
      );
      return false;
    } else if (this.businessLogic.name === 'NEW') {
      this.errors['name'] = <string>this.translator.instant('INVALID_NAME');
      return false;
    } else if (!this.businessLogic.organizationCategorySelected.idCategory) {
      this.errors['organization'] = <string>(
        this.translator.instant('ORGANIZATION_SELECT')
      );
      return false;
    } else if (!this.businessLogic.type || this.businessLogic.type == '') {
      this.errors['type'] = <string>this.translator.instant('TYPE_SELECT');
      return false;
    }

    if (this.businessLogic.type.length <= 0) {
      this.errors['type'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else if (
      !this.businessLogic.description ||
      this.businessLogic.description.length <= 0
    ) {
      this.errors['description'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else if (this.businessLogic.description.length > 255) {
      this.errors['description'] = <string>(
        this.translator.instant('MAX_LONGITUD', { max: 255 })
      );
      return false;
    } else if (
      !this.businessLogic.json ||
      this.businessLogic.json.length <= 0
    ) {
      this.errors['json'] = <string>(
        this.translator.instant('AL_MENOS_1_CARACTER')
      );
      return false;
    } else {
      return true;
    }
  }

  getOrganizations() {
    this.businessLogicSrv
      .getOrganizationList()
      .subscribe((res) => (this.businessLogic.categories = res.categories));
  }

  getCategoryTypes() {
    this.configurationTypeSrv.getAll().subscribe((res) => {
      this.typeOptions = res;
      this.filteredTypeOptions = res;
    });
  }

  updateList() {
    if (!this.typeOptions.some(x => x.type == this.businessLogic.type)) {
      const newType = { id: null, type: this.businessLogic.type.toUpperCase()};
      this.configurationTypeSrv.create(newType).then((res) => {
        this.typeOptions.push(res);
        this.businessLogic.type = res.type;
      });
    } else {
      this.errors['type'] = <string>this.translator.instant('TYPE_EXIST');
      return false;
    }
  }

  findInTypeOptions(value: string): void {
    if (value == '') this.showFilterTypeOptions = false;
    else {
      const finded = this.typeOptions.filter((x) =>
        x.type.toLowerCase().includes(value.toLowerCase())
      );
      if (finded.length > 0) {
        this.filteredTypeOptions = finded;
        this.showFilterTypeOptions = true;
        this.showAddTypeButton = false;
      } else {
        this.filteredTypeOptions = this.typeOptions;
        this.showFilterTypeOptions = false;
        this.showAddTypeButton = true;
      }
    }
  }

  selectBusinessLogicType(type: string) {
    this.businessLogic.type = type;
    this.showFilterTypeOptions = false;
    this.showAddTypeButton = false
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/businesslogic/detail/detail-business-logic.component.ts